// extracted by mini-css-extract-plugin
module.exports = {"container":"container__1CKoB","faq":"faq__3ZOzk","breadcrumbs":"breadcrumbs__2Mztj"};